/** Debug hooks: always in dev builds; in release only when the page is opened with `?debug`. */
export const DEBUG = import.meta.env.DEV || new URLSearchParams(location.search).has("debug");
